module.exports = __webpack_public_path__ + "static/img/6.4cb158e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/sp/6.png
// module id = +gfY
// module chunks = 0